import { Stack } from '@etg/wings';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { Bounds } from '../../../../../widgets/trip-details/components/TripDetailsContent';
import TripDetailsBoundSkeleton from './TripDetailsBoundSkeleton';
import QuickSortButtonBarSkeleton from './QuickSortButtonBarSkeleton';
import TripTicketTypeSkeleton from './TripTicketTypeSkeleton';

const wrapperStyles = css`
  height: 100%;
`;

const buttonWrapperSkeletonStyles = css`
  background-color: ${etiColors.grayScale[2]};
  border-bottom-left-radius: 0.1875rem;
  border-bottom-right-radius: 0.1875rem;
  border-top: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media ${mediaQueries.medium.up} {
    flex-direction: row;
  }
`;

const resultWrapperStyles = css`
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  box-shadow: 0 0 8px hsl(0deg 0% 0% / 12%);
  overflow: hidden;
`;

const skeletonBounds = [
  { boundId: '1', segments: [{ id: '1' }, { id: '2' }] },
  { boundId: '2', segments: [{ id: '3' }, { id: '4' }] },
];

const skeletonFlights = [
  { id: '1', bounds: skeletonBounds },
  { id: '2', bounds: skeletonBounds },
  { id: '3', bounds: skeletonBounds },
  { id: '4', bounds: skeletonBounds },
  { id: '5', bounds: skeletonBounds },
  { id: '6', bounds: skeletonBounds },
  { id: '7', bounds: skeletonBounds },
  { id: '8', bounds: skeletonBounds },
  { id: '9', bounds: skeletonBounds },
  { id: '10', bounds: skeletonBounds },
];

const SearchResultsSkeleton = () => (
  <Stack className={wrapperStyles} data-testid="resultPage-searchResults-skeleton" spacing={16}>
    <QuickSortButtonBarSkeleton />

    <Stack spacing={24}>
      {skeletonFlights.map(({ bounds, id }) => (
        <div className={resultWrapperStyles} key={id}>
          <Bounds data-testid="tripDetails-skeleton-bounds">
            {bounds.map((bound) => (
              <TripDetailsBoundSkeleton key={bound.boundId} />
            ))}
          </Bounds>
          <div className={buttonWrapperSkeletonStyles}>
            <TripTicketTypeSkeleton />
            <TripTicketTypeSkeleton />
          </div>
        </div>
      ))}
    </Stack>
  </Stack>
);

export default SearchResultsSkeleton;
